










import { defineComponent, PropType } from '@vue/composition-api';

export default defineComponent({
  name: 'Button',
  props: {
    size: {
      type: String as PropType<'small' | 'normal'>,
      default: 'normal',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String as PropType<'primary' | 'ghost'>,
      default: 'primary',
    },
  },
  setup(props, { emit }) {
    return {
      onClick() {
        emit('click');
      },
    };
  },
});
